import React, { Component } from 'react'
import Header from './components/Header'
import Footer from './components/Footer'
import Login from './containers/Login'
import { strings } from './localization'

export default class App extends Component {

	state = {
		logoutFeedbackFailure: '',
		logoutFeedbackSuccess: '',
		isLogoutFailure: false,
		isLogoutSuccess: false
	}

	componentDidMount = () => {
		strings.setLanguage('nb')
		if (window.DATA !== undefined) {

			let isLogoutFailure = false
			let logoutFeedbackFailure = ''

			let isLogoutSuccess = false
			let logoutFeedbackSuccess = ''

			if (window.DATA.isLogoutFailure &&
				window.DATA.logoutFeedbackFailure &&
				window.DATA.logoutFeedbackFailure !== 'null') {
				isLogoutFailure = JSON.parse(window.DATA.isLogoutFailure)
				logoutFeedbackFailure = window.DATA.logoutFeedbackFailure
			}

			if (window.DATA.isLogoutSuccess &&
				window.DATA.logoutFeedbackSuccess &&
				window.DATA.logoutFeedbackSuccess !== 'null') {
				isLogoutSuccess = JSON.parse(window.DATA.isLogoutSuccess)
				logoutFeedbackSuccess = window.DATA.logoutFeedbackSuccess
			}

			this.setState({
				logoutFeedbackFailure,
				logoutFeedbackSuccess,
				isLogoutFailure,
				isLogoutSuccess
			})
		}
	}

	render() {
		const { isLogoutFailure, logoutFeedbackFailure, isLogoutSuccess, logoutFeedbackSuccess } = this.state

		return (
			<div className="app">
				<Header />
				<Login
					isLogoutFailure={isLogoutFailure}
					logoutFeedbackFailure={logoutFeedbackFailure}
					isLogoutSuccess={isLogoutSuccess}
					logoutFeedbackSuccess={logoutFeedbackSuccess} />
				<Footer />
			</div>
		)
	}
}

